import React from "react";

interface SupportToggleProps {
  isOn: boolean;
  onChange: (value: boolean) => void;
  id?: string;
  disabled?: boolean;
}

const SupportToggle: React.FC<SupportToggleProps> = ({
  isOn,
  onChange,
  id,
  disabled = false,
}) => (
  <button
    type="button"
    id={id}
    className={`contract-status-card__support-toggle ${
      isOn ? "contract-status-card__support-toggle--on" : ""
    }`}
    onClick={() => onChange(!isOn)}
    role="switch"
    aria-checked={isOn}
    aria-label="Can we support this partner now"
    disabled={disabled}
  >
    <span className="contract-status-card__support-toggle-track" aria-hidden>
      <span className="contract-status-card__support-toggle-thumb" />
    </span>
  </button>
);

export default SupportToggle;
